import { createFileRoute } from "@tanstack/react-router";
import { RoadmapPage } from "../../../components/system/RoadmapPage";
import { requireSuperAdmin } from "../../../lib/auth/route-protection";

export const Route = createFileRoute("/system/roadmap/")({
  beforeLoad: requireSuperAdmin(),
  component: RoadmapRoute,
});

function RoadmapRoute() {
  return <RoadmapPage />;
}
